







































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

type FormValues = {
  [key: string]: string | boolean | number | null
}

type AdditionalFields = {
  name: string
  validation?: string
  type: string
  options: {
    value: string
    label: string
  }[]
}

@Component
export default class MitmachenForm extends Vue {
  @Prop({ type: String, required: false }) readonly promotion!: string
  @Prop({ type: Function, default: (_: string) => {} }) readonly onCode!: (
    code: string
  ) => void

  @Prop({ type: String, default: 'bail|required|codeRule' })
  readonly codeValidation!: string

  @Prop({ type: Boolean, default: false }) readonly codeError!: boolean
  @Prop({ type: Number, default: 50 }) readonly codeLength!: number

  @Prop({ type: Array, default: () => [] })
  readonly additionalNosubscriberOffers!: AdditionalFields[]

  private mitmachen: FormValues = {
    abono: '',
    address: '',
    address_number: '',
    birthdate: '',
    code: (this.$route.query.code as string) ?? '',
    email: '',
    firstname: '',
    is_subscriber: '',
    lastname: '',
    newsletter: false,
    offers: false,
    phone: '',
    privacy: false,
    sex: '',
    town: '',
    zip: '',
    order_online_test: false,
    order_print_test: false,
    promotion: null,
  }

  public error: Error | null = null
  public success: boolean = false
  public loading: boolean = false

  get birthdateField() {
    if (process.client) {
      if (/android/i.test(navigator.userAgent)) {
        return 'text'
      }
    }
    return 'date'
  }

  @Watch('mitmachen')
  onMitmachenChange(val: FormValues, oldVal: FormValues) {
    if (val.code !== oldVal.code) {
      this.$emit('on-code', val.code)
    }
  }

  nameRule({ value }: { value: string }): boolean {
    return value.match(/^[A-Za-zäëïöüÄËÏÖÜàéèîôûÀÉÈÎÔÛß-\s.]*$/gm) !== null
  }

  houseNumberRule({ value }: { value: string }): boolean {
    return value.match(/^[A-Za-z0-9äëïöüÄËÏÖÜàéèîôûÀÉÈÎÔÛß\s/]*$/gm) !== null
  }

  codeRule({ value }: { value: string }): boolean {
    return value.match(/^[A-Za-z0-9äëïöüÄËÏÖÜàéèîôûÀÉÈÎÔÛß&-\s.]*$/gm) !== null
  }

  phoneRule({ value }: { value: string }): boolean {
    return (
      value.match(
        /^(((((((00|\+)[0-9]{2}[ \-/]?)|0)[1-9][0-9]{1,4})[ \-/]?)|((((00|\+)[0-9]{2}\()|\(0)[1-9][0-9]{1,4}\)[ \-/]?))[0-9]{1,7}([ \-/]?[0-9]{1,5})?)$/gm
      ) !== null
    )
  }

  dateRule({ value }: { value: string }): boolean {
    if (this.birthdateField === 'date') {
      return true
    }
    return (
      value.match(
        /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d\d$/
      ) !== null
    )
  }

  testAboRule({ getFormValues }: { getFormValues: () => FormValues }): boolean {
    const formValues = getFormValues()
    if (formValues.is_subscriber === 'Ja') return true
    else if (formValues.is_subscriber === 'Nein') {
      if (this.additionalNosubscriberOffers.length > 0) {
        return this.additionalNosubscriberOffers.every((offer) => {
          if (offer.validation === 'required') {
            return formValues[offer.name] !== undefined
          }
          return true
        })
      }
      return (
        formValues.order_online_test === true ||
        formValues.order_print_test === true
      )
    }
    return false
  }

  handleAcceptAll(v: boolean) {
    this.mitmachen.newsletter = v
    this.mitmachen.offers = v
    this.mitmachen.privacy = v
  }

  handleIsSubscriberChange(v: String) {
    if (this.additionalNosubscriberOffers.length > 0) return
    if (v === 'Ja') {
      this.mitmachen.order_online_test = false
      this.mitmachen.order_print_test = false
    } else {
      this.mitmachen.order_online_test = true
    }
  }

  toggleTestAbo() {
    if (this.additionalNosubscriberOffers.length > 0) return
    this.mitmachen.order_online_test = !this.mitmachen.order_online_test
    this.mitmachen.order_print_test = !this.mitmachen.order_print_test
  }

  async submitData() {
    this.loading = true
    const userData: { [key: string]: string | boolean | number | null } = {
      ...this.mitmachen,
      is_subscriber: this.mitmachen.is_subscriber === 'Ja',
    }

    if (this.birthdateField === 'text') {
      const [day, month, year] = (this.mitmachen.birthdate as string).split('.')
      userData.birthdate = `${year}-${month}-${day}`
    }

    if (this.promotion) {
      userData.promotion = this.promotion
    }

    const additionalFields = {} as {
      [key: string]: string | boolean | number | null
    }
    const finalData = Object.keys(userData).reduce((carry, key: string) => {
      if (key.startsWith('additional_fields.')) {
        additionalFields[key.replace(`additional_fields.`, ``)] = userData[key]
        carry.additional_fields = JSON.stringify(additionalFields)
      } else {
        carry[key] = userData[key]
      }
      return carry
    }, {} as { [key: string]: string | boolean | number | null })

    try {
      const mutation = require('~base/graphql/mutations/ParticipateToRaffle.gql')
      const apolloClient = this.$apolloProvider.defaultClient
      await apolloClient.mutate({
        mutation,
        variables: finalData,
      })
      this.success = true
      if (this.mitmachen.newsletter) {
        // fire and forget
        await apolloClient.mutate({
          mutation: require('~base/graphql/mutations/SubscribeNewsletter.gql'),
          variables: {
            email: this.mitmachen.email,
            lists: ['MORNING'],
          },
        })
      }
    } catch (e: any) {
      console.error(e)
      this.error = new Error('Fehler beim Speichern der Daten!')
    }
    this.loading = false
  }
}
